<template>
    <div class="uik-cta">
        <div v-if="!split" class="uik-cta__row">
            <slot></slot>
        </div>
        <div v-if="split" class="uik-cta__column">
            <div class="uik-cta__column-top"><slot name="top"></slot></div>
            <div class="uik-cta__column-bottom"><slot name="bottom"></slot></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "UikCta",
    props: {
        split: { type: Boolean, default: false }
    }
}
</script>

<style lang="scss">
.uik-cta {
    display: flex;
    justify-content: center;
    align-items: center;
    .uik-cta__row {
        display: inline-flex;
        flex-flow: row nowrap;
        justify-content: flex-end;
        align-items: center;
        > * {
            margin: 0 5px;
        }
        > *:first-child {
            margin-left: 0;
        }
        > *:last-child {
            margin-right: 0;
        }
    }
    .uik-cta__column {
        display: inline-flex;
        flex-flow: column nowrap;
        justify-content: flex-start;
        align-items: center;
        > *:first-child {
            margin-bottom: 2px;
        }
        .uik-cta__column-top, .uik-cta__column-bottom {
            width: 100%;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            > * {
                margin: 0 5px;
            }
            > *:first-child {
                margin-left: 0;
            }
            > *:last-child {
                margin-right: 0;
            }
        }
        .uik-cta__column-top {
            margin-bottom: 10px;
        }
    }
    button {
        .uik-btn__content {
            span {
                margin-top: 0;
            }
        }
    }
    button.uik-btn__clear.uik-btn__iconOnly {
        padding: 0;
        flex-basis: 20px;
        i {
            color: $textBase;
        }
        &:hover {
            i {
            color: $primary;
            }
        }
    }
    @media only #{$mediaMobile} {
        .uik-cta__row {
            flex-direction: column-reverse;
            align-items: flex-end;
            > * {
                margin: 5px 0;
            }
            margin-bottom: 0;
        }
        .uik-cta__column {
            .uik-cta__column-top {
                flex-direction: column-reverse;
                align-items: flex-end;
                > * {
                    margin: 5px 0;
                }
                margin-bottom: 0;
            }
            .uik-cta__column-bottom {
                flex-direction: column-reverse;
                align-items: flex-end;
                > * {
                    margin: 5px 0;
                }
            }
        }
    }
}
</style>
